import React from "react";
import {
  AlertDialog as AlertDialogPrimitive,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../primitives/AlertDialogPrimitive";

interface AlertDialogProps {
  open: boolean;
  title: string;
  description: any;
  actionLabel: string;
  onActionPress: () => void;
  cancelLabel?: string;
  onCancelPress?: () => void;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  title,
  description,
  actionLabel,
  onActionPress,
  cancelLabel,
  onCancelPress,
}) => {
  return (
    <AlertDialogPrimitive open={open}>
      <AlertDialogContent>
        <AlertDialogHeader className="dark:bg-[#2c2c35]">
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="overflow-auto max-h-60">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={onActionPress}
            className="bg-gradient-to-r from-[#EF533D] to-[#F39537]"
          >
            {actionLabel}
          </AlertDialogAction>
          {cancelLabel && onCancelPress && (
            <AlertDialogCancel onClick={onCancelPress}>
              {cancelLabel}
            </AlertDialogCancel>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogPrimitive>
  );
};
